export const ANNOTATE_REQUEST = 'ANNOTATE_REQUEST';
export const ANNOTATE_SUCCESS = 'ANNOTATE_SUCCESS';
export const ANNOTATE_ERROR = 'ANNOTATE_ERROR';
export const ANNOTATE_RESET = 'ANNOTATE_RESET';
export const ANNOTATE_CANCEL = 'ANNOTATE_CANCEL';
export const TOGGLE_ANNOTATION_VISIBILITY = 'TOGGLE_ANNOTATION_VISIBILITY';
export const TOGGLE_ANNOTATIONS_VISIBILITY = 'TOGGLE_ANNOTATIONS_VISIBILITY';
export const SELECT_ANNOTATOR_RESULT = 'SELECT_ANNOTATOR_RESULT';
export const DESELECT_ANNOTATOR_RESULT = 'DESELECT_ANNOTATOR_RESULT';
export const RESET_ANNOTATIONS_FOR_TEST_SET_ENTRY =
  'RESET_ANNOTATIONS_FOR_TEST_SET_ENTRY';
